import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { ScrollDebouncer } from "core/classes/scroll/scroll.debouncer.class";

var loadContentFlag = false,
  adFlowFlag = false,
  readyFlag = false,
  nativeFlag = true;
$(window).on("abacus:loadcontent:complete", function(evt, context) {
  loadContentFlag = true;
  loadClass();
});
$(window).on("abacus:advertb:loaded", function() {
  adFlowFlag = true;
  loadClass();
});
$(window).on("load", function() {
  readyFlag = true;
  loadClass();
});

$(window).on("abacus:nativecontent:loaded", function(evt, context) {
  loadClass();
});

function loadClass() {
  if (loadContentFlag && adFlowFlag && readyFlag && nativeFlag) {
    $(".stickyAd").each(function() {
      new StickyDiv(this);
    });
  } else {
    return false;
  }
}

class StickyDiv extends Class {
  constructor(element) {
    super();
    this.element = $(element);
    this.setUpElements();
    this.setUpEvents();
  }

  setUpElements() {
    this.win = $(window);
    this.container = this.element.parent();
    this.top = this.element.offset().top;
    this.wrapper = this.element.parents(".inner-sleeve");
  }

  setUpEvents() {
    var self = this;
    this.checkStayUnstuck();
    $(ScrollDebouncer).on("scroll", function() {
      self.onScroll();
    });
  }

  onScroll() {
    var windowTop = this.win.scrollTop();
    var elementTop = this.element.offset().top;
    if (this.element.hasClass("stayUnstuck")) {
      return;
    } else {
      this.checkBeforeStick(windowTop);
    }
    this.checkForEnd();
  }

  checkStayUnstuck() {
    var containerBottom =
      this.win.height() - this.wrapper.offset().top - this.wrapper.height();
    var elementBottom =
      this.win.height() - this.top - this.element.height() - 75;
    if (containerBottom >= elementBottom) {
      this.element.addClass("stayUnstuck");
    }
  }

  checkBeforeStick(windowTop) {
    if (windowTop >= this.top - 100) {
      this.stick();
    } else {
      this.unStick();
    }
  }

  checkForEnd() {
    var scroll =
      this.wrapper.offset().top +
      this.wrapper.height() -
      75 -
      this.win.scrollTop();
    var elemHeight = this.element.height() + 25;

    if (this.element.hasClass("stayUnstuck")) {
      return;
    } else {
      this.checkBottomOfWrapper(scroll, elemHeight);
    }
  }

  checkBottomOfWrapper(scroll, elemHeight) {
    if (scroll <= elemHeight) {
      this.element.addClass("unStuck");
    } else {
      this.element.removeClass("unStuck");
    }
  }

  stick() {
    if (!this.element.hasClass("stuck")) {
      this.element.addClass("stuck");
      this.wrapper.addClass("stickyWrapper");
    }
  }

  unStick() {
    if (this.element.hasClass("stuck")) {
      this.element.removeClass("stuck");
    }
  }
}

export { StickyDiv };



// WEBPACK FOOTER //
// ./Javascript/core/classes/sticky.class.js